import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CardContent,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import FilterBar from './FilterBar';

const Arrow = ({ direction }) => {
  const styles = {
    display: 'inline-block',
    marginRight: '8px',
    width: 0,
    height: 0,
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
  };

  if (direction === 'up') {
    return (
      <span
        style={{
          ...styles,
          borderBottom: '10px solid green',
        }}
      ></span>
    );
  } else if (direction === 'down') {
    return (
      <span
        style={{
          ...styles,
          borderTop: '10px solid red',
        }}
      ></span>
    );
  } else {
    return null;
  }
};

const NotesCard = ({
  title,
  filters,
  dateErrors = {},
  onSectionChange,
  onSearchChange,
  onPeriodChange,
  onDateChange = () => {},
  onPageChange,
  paginatedNotes,
  totalPages,
  currentPage,
  sections,
  notes,
  periods,
  showPeriodFilter = false,
  historical = false,
  sortBy = 'quality',
  sortOrder = 'desc',
  onSortChange,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        background: '#fff',
        padding: '20px',
        marginTop: 2,
        marginBottom: '1em',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6" sx={{ padding: '1rem' }}>
          {title}
        </Typography>
        <FilterBar
          filters={filters}
          dateErrors={dateErrors}
          onSectionChange={onSectionChange}
          onSearchChange={onSearchChange}
          onPeriodChange={onPeriodChange}
          onDateChange={onDateChange}
          sections={sections}
          notes={notes}
          periods={periods}
          showPeriodFilter={showPeriodFilter}
        />
      </Box>

      <CardContent>
        {paginatedNotes?.length > 0 ? (
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderBottom: 'none',
                      padding: '16px 24px',
                      fontWeight: 600,
                    }}
                  >
                    <Button
                      onClick={() => onSortChange && onSortChange('title')}
                      sx={{
                        color: 'inherit',
                        fontWeight: 600,
                        textTransform: 'none',
                        minWidth: 'auto',
                        padding: 0,
                        '&:hover': {
                          backgroundColor: 'transparent',
                          textDecoration: 'underline',
                        },
                      }}
                      endIcon={
                        sortBy === 'title' ? (
                          sortOrder === 'desc' ? (
                            <KeyboardArrowDown />
                          ) : (
                            <KeyboardArrowUp />
                          )
                        ) : null
                      }
                    >
                      Título
                    </Button>
                  </TableCell>
                  {historical && (
                    <TableCell
                      sx={{
                        borderBottom: 'none',
                        padding: '16px 24px',
                        fontWeight: 600,
                      }}
                    >
                      <Button
                        onClick={() => onSortChange && onSortChange('author')}
                        sx={{
                          color: 'inherit',
                          fontWeight: 600,
                          textTransform: 'none',
                          minWidth: 'auto',
                          padding: 0,
                          '&:hover': {
                            backgroundColor: 'transparent',
                            textDecoration: 'underline',
                          },
                        }}
                        endIcon={
                          sortBy === 'author' ? (
                            sortOrder === 'desc' ? (
                              <KeyboardArrowDown />
                            ) : (
                              <KeyboardArrowUp />
                            )
                          ) : null
                        }
                      >
                        Autor
                      </Button>
                    </TableCell>
                  )}
                  {historical && (
                    <TableCell
                      sx={{
                        borderBottom: 'none',
                        padding: '16px 24px',
                        fontWeight: 600,
                      }}
                    >
                      <Button
                        onClick={() => onSortChange && onSortChange('date')}
                        sx={{
                          color: 'inherit',
                          fontWeight: 600,
                          textTransform: 'none',
                          minWidth: 'auto',
                          padding: 0,
                          '&:hover': {
                            backgroundColor: 'transparent',
                            textDecoration: 'underline',
                          },
                        }}
                        endIcon={
                          sortBy === 'date' ? (
                            sortOrder === 'desc' ? (
                              <KeyboardArrowDown />
                            ) : (
                              <KeyboardArrowUp />
                            )
                          ) : null
                        }
                      >
                        Fecha de publicación
                      </Button>
                    </TableCell>
                  )}
                  {historical && (
                    <TableCell
                      sx={{
                        borderBottom: 'none',
                        padding: '16px 24px',
                        fontWeight: 600,
                      }}
                    >
                      <Button
                        onClick={() => onSortChange && onSortChange('category')}
                        sx={{
                          color: 'inherit',
                          fontWeight: 600,
                          textTransform: 'none',
                          minWidth: 'auto',
                          padding: 0,
                          '&:hover': {
                            backgroundColor: 'transparent',
                            textDecoration: 'underline',
                          },
                        }}
                        endIcon={
                          sortBy === 'category' ? (
                            sortOrder === 'desc' ? (
                              <KeyboardArrowDown />
                            ) : (
                              <KeyboardArrowUp />
                            )
                          ) : null
                        }
                      >
                        Categoría
                      </Button>
                    </TableCell>
                  )}
                  {!historical && (
                    <TableCell
                      sx={{
                        borderBottom: 'none',
                        padding: '16px 24px',
                        fontWeight: 600,
                      }}
                    >
                      Vistas
                    </TableCell>
                  )}
                  {!historical && (
                    <TableCell
                      sx={{
                        borderBottom: 'none',
                        padding: '16px 24px',
                        fontWeight: 600,
                      }}
                    >
                      Usuarios Activos
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      borderBottom: 'none',
                      padding: '16px 24px',
                      fontWeight: 600,
                    }}
                  >
                    <Button
                      onClick={() => onSortChange && onSortChange('quality')}
                      sx={{
                        color: 'inherit',
                        fontWeight: 600,
                        textTransform: 'none',
                        minWidth: 'auto',
                        padding: 0,
                        '&:hover': {
                          backgroundColor: 'transparent',
                          textDecoration: 'underline',
                        },
                      }}
                      endIcon={
                        sortBy === 'quality' ? (
                          sortOrder === 'desc' ? (
                            <KeyboardArrowDown />
                          ) : (
                            <KeyboardArrowUp />
                          )
                        ) : null
                      }
                    >
                      Calidad
                    </Button>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedNotes.map(note => {
                  const formatDate = dateString => {
                    if (!dateString) return '';
                    const date = new Date(dateString);
                    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
                  };

                  const titleLink = note.url
                    ? `${process.env.REACT_APP_URL_CLIENT}${note.url}`
                    : null;

                  return (
                    <TableRow
                      key={note.id}
                      sx={{
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.02)',
                          transition: 'background-color 0.2s ease-in-out',
                        },
                        borderBottom: '1px solid rgba(224, 224, 224, 0.3)',
                        '&:last-child': {
                          borderBottom: 'none',
                        },
                      }}
                    >
                      <TableCell
                        sx={{
                          padding: '24px 24px',
                          maxWidth: '400px',
                          borderBottom: 'none',
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          {note?.image ? (
                            <img
                              src={note.image}
                              alt="Note"
                              style={{
                                width: '80px',
                                height: '80px',
                                objectFit: 'cover',
                                marginRight: '16px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                              }}
                            />
                          ) : null}
                          {titleLink ? (
                            <a
                              href={titleLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: '#1d1d1d',
                                textDecoration: 'none',
                                fontWeight: '600',
                                fontSize: '14px',
                                lineHeight: '1.4',
                                transition: 'color 0.2s ease',
                              }}
                              onMouseEnter={e => {
                                e.target.style.color = '#000000';
                                e.target.style.textDecoration = 'underline';
                              }}
                              onMouseLeave={e => {
                                e.target.style.color = '#1d1d1d';
                                e.target.style.textDecoration = 'none';
                              }}
                            >
                              {note.title || '-'}
                            </a>
                          ) : (
                            <Typography
                              sx={{
                                fontWeight: '600',
                                padding: '16px 0',
                                fontSize: '14px',
                                lineHeight: '1.4',
                                color: 'text.primary',
                              }}
                            >
                              {note.title || '-'}{' '}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>
                      {historical && (
                        <TableCell
                          sx={{
                            padding: '24px 24px',
                            borderBottom: 'none',
                            color: 'text.secondary',
                            fontSize: '14px',
                          }}
                        >
                          {note.author || '-'}
                        </TableCell>
                      )}
                      {historical && (
                        <TableCell
                          sx={{
                            padding: '24px 24px',
                            borderBottom: 'none',
                            color: 'text.secondary',
                            fontSize: '14px',
                          }}
                        >
                          {formatDate(note.date || note.created_at) || '-'}
                        </TableCell>
                      )}
                      {historical && (
                        <TableCell
                          sx={{
                            padding: '24px 24px',
                            borderBottom: 'none',
                            color: 'text.secondary',
                            fontSize: '14px',
                          }}
                        >
                          <Box
                            sx={{
                              backgroundColor: 'rgba(25, 118, 210, 0.08)',
                              color: '#1976d2',
                              padding: '4px 12px',
                              borderRadius: '16px',
                              fontSize: '12px',
                              fontWeight: '500',
                              display: 'inline-block',
                              textTransform: 'capitalize',
                            }}
                          >
                            {note.category || '-'}
                          </Box>
                        </TableCell>
                      )}
                      {!historical && (
                        <TableCell
                          sx={{
                            padding: '24px 24px',
                            borderBottom: 'none',
                            fontWeight: '600',
                            color: 'text.primary',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                            }}
                          >
                            {(
                              note.screen_page_views ||
                              note.screenPageViews ||
                              0
                            ).toLocaleString()}
                          </Box>
                        </TableCell>
                      )}
                      {!historical && (
                        <TableCell
                          sx={{
                            padding: '24px 24px',
                            borderBottom: 'none',
                            fontWeight: '600',
                            color: 'text.primary',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                            }}
                          >
                            {(
                              note.active_users ||
                              note.activeUsers ||
                              0
                            ).toLocaleString()}
                          </Box>
                        </TableCell>
                      )}
                      <TableCell
                        sx={{
                          padding: '24px 24px',
                          borderBottom: 'none',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            paddingLeft: note?.quality_trend ? '20px' : '0px',
                            position: 'relative',
                          }}
                        >
                          {note?.quality_trend && (
                            <Box
                              sx={{
                                position: 'absolute',
                                left: '0px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                              }}
                            >
                              <Arrow direction={note.quality_trend} />
                            </Box>
                          )}
                          <strong>{note.quality || '-'}</strong>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Box sx={{ textAlign: 'center', padding: '2rem' }}>
            <Typography sx={{ fontWeight: 'bold', color: '#999' }}>
              No hay notas que coincidan con los criterios de búsqueda.
            </Typography>
          </Box>
        )}
      </CardContent>

      {totalPages > 1 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '1rem',
          }}
        >
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={onPageChange}
            size="medium"
          />
        </Box>
      )}
    </Card>
  );
};

export default NotesCard;
